import * as React from 'react';
import './ForgotPasswordView.scss';
import ForgotPassword from './components/ForgotPassword';

export function ForgotPasswordView() {
  return (
    <div className="rp-forgotpasswordview">
      <ForgotPassword mode="forgot" />
    </div>
  );
}
